const PropertyDetail = [
    {
        id:"1",
        Image:require('../img/3.jpg'),
        heading:"Comfortable Apartment in Palace",
        span:"Popular Properties",
        amount:"From $20K",
        size:"1200 Sqft",
        bed:"2 Bed",
        bedImage:require('../img/double-bed.png'),
        bath:"2 Bathroom",
        bathImage:require('../img/bath.png')
    },
    {
        id:"2",
        Image:require('../img/4.jpg'),
        heading:"Comfortable Apartment in Palace",
        span:"Popular Properties",
        amount:"From $20K",
        size:"1200 Sqft",
        bed:"2 Bed",
        bedImage:require('../img/double-bed.png'),
        bath:"2 Bathroom",
        bathImage:require('../img/bath.png')
    },
    {
        id:"3",
        Image:require('../img/5.jpg'),
        heading:"Comfortable Apartment in Palace",
        span:"Popular Properties",
        amount:"From $20K",
        size:"1200 Sqft",
        bed:"2 Bed",
        bedImage:require('../img/double-bed.png'),
        bath:"2 Bathroom",
        bathImage:require('../img/bath.png')
    },
    {
        id:"4",
        Image:require('../img/6.jpg'),
        heading:"Comfortable Apartment in Palace",
        span:"Popular Properties",
        amount:"From $20K",
        size:"1200 Sqft",
        bed:"2 Bed",
        bedImage:require('../img/double-bed.png'),
        bath:"2 Bathroom",
        bathImage:require('../img/bath.png')
    },
    {
        id:"5",
        Image:require('../img/7.jpg'),
        heading:"Comfortable Apartment in Palace",
        span:"Popular Properties",
        amount:"From $20K",
        size:"1200 Sqft",
        bed:"2 Bed",
        bedImage:require('../img/double-bed.png'),
        bath:"2 Bathroom",
        bathImage:require('../img/bath.png')
    },
    {
        id:"6",
        Image:require('../img/8.jpg'),
        heading:"Comfortable Apartment in Palace",
        span:"Popular Properties",
        amount:"From $20K",
        size:"1200 Sqft",
        bed:"2 Bed",
        bedImage:require('../img/double-bed.png'),
        bath:"2 Bathroom",
        bathImage:require('../img/bath.png')
    }
]
export default PropertyDetail